import gql from "graphql-tag";

const READ_NOTIFICATION_MUTATION = gql`
  mutation ReadNotification($notificationId: [Int!]) {
    markNotificationAsRead(notificationId: $notificationId)
  }
`;

export default READ_NOTIFICATION_MUTATION;
